import React from "react";
import AppWrapper from "./components/AppWrapper";
import { BrowserRouter } from "react-router-dom";
import { Switch } from "react-router";
import { withFbaseAuthentication } from "./fbase";
import { useTitle } from "react-use";
import { useMe } from "./hooks/useMe";
import { AllRoutes } from "./pages-routes";
import { DOCUMENT_TITLE_AND_HEADER_TEXT } from "./styles/constants";
import { Spinner } from "@blueprintjs/core";
import { useSmartlook } from "./hooks/use-smartlook";

function App() {
  useTitle(DOCUMENT_TITLE_AND_HEADER_TEXT);

  const me = useMe();

  useSmartlook(me.initialData);

  if (me.loading) {
    return (
      <AppWrapper hideLeftNav={true}>
        <Spinner />
      </AppWrapper>
    );
  } else {
    return (
      <div className="bp3-dark">
        <BrowserRouter>
          <Switch>{AllRoutes}</Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default withFbaseAuthentication(App);
